<app-header [showMenu]="m_viewOnly">
</app-header>
<app-wizard-upgrade [viewModeOnly]="m_viewOnly"></app-wizard-upgrade>
